import React, { useState } from 'react';
import Button from '../../../../../../components/Button';
import Heading from '../../../../../../components/Heading';
import cx from 'classnames';
import styles from './StepDeleteModal.module.scss';

interface StepDeleteModalProps {
    stepNumber: number;
    stepTitle: string;
    fieldsCount: number;
    onConfirm: (stepNumber: number) => void;
    onCancel: () => void;
}

const StepDeleteModal: React.FC<StepDeleteModalProps> = ({
    stepNumber,
    stepTitle,
    fieldsCount,
    onConfirm,
    onCancel
}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = () => {
        setIsDeleting(true);
        try {
            onConfirm(stepNumber);
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className={cx(styles['modal-content'])}>
            <div className={cx(styles['modal-heading'])}>
                <Heading level={3} classes="modal-heading">
                    Schritt löschen
                </Heading>
            </div>

            <div className={cx(styles['modal-heading'])}>
                <p className={cx(styles['warning-text'])}>
                    Möchten Sie den Schritt <strong>"{stepTitle}"</strong> wirklich löschen?
                </p>
                <p className={cx(styles['danger-text'])}>
                    Dieser Schritt enthält {fieldsCount} Feld{fieldsCount !== 1 ? 'er' : ''} und wird ebenfalls gelöscht!
                </p>
                <p className={cx(styles['info-text'])}>
                    Diese Aktion kann nicht rückgängig gemacht werden.
                </p>
            </div>

            <div className={cx(styles['button-container'])}>
                <Button
                    type="button"
                    hierarchy="secondary"
                    fn={onCancel}
                    disabled={isDeleting}
                    text="Abbrechen"
                />
                <Button
                    type="button"
                    hierarchy="primary"
                    fn={handleConfirm}
                    disabled={isDeleting}
                    text={isDeleting ? 'Lösche...' : 'Schritt löschen'}
                />
            </div>
        </div>
    );
};

export default StepDeleteModal; 